export default "__VITE_ASSET__C4Wr2LqJ__"